import { Cpu, RefreshCw, FileText, UserCheck, PersonStanding, Smartphone, ArrowUpRight, Bot } from "lucide-react";
import { MODULES, ROBOTICS, PARTNERS, PATENT_LINE, IMAGES, CONTACT } from "./data";
import { Reveal, SectionHead } from "./shared";

const ICONS = { Cpu, RefreshCw, FileText, UserCheck, PersonStanding, Smartphone };

export default function Products() {
  return (
    <section id="product" data-testid="product-section" className="mx-auto max-w-7xl px-5 py-24 lg:px-8 lg:py-32">
      <SectionHead
        index="01"
        overline="The Product"
        title="Six products. One safety platform."
        note={PATENT_LINE}
      />

      <div className="grid grid-cols-1 gap-px overflow-hidden rounded-lg border border-slate-800 bg-slate-800 md:grid-cols-2 lg:grid-cols-3">
        {MODULES.map((m, i) => {
          const Icon = ICONS[m.icon];
          return (
            <Reveal key={m.name} delay={i * 0.06} y={20} className="h-full">
              <div
                data-testid={`module-${m.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className="group relative flex h-full flex-col bg-[#0D1320] p-7 transition-colors duration-300 hover:bg-[#111827]"
              >
                <span className="absolute left-0 top-0 h-6 w-6 border-l-2 border-t-2 border-transparent transition-colors duration-300 group-hover:border-[#FF5500]" />
                <span className="absolute bottom-0 right-0 h-6 w-6 border-b-2 border-r-2 border-transparent transition-colors duration-300 group-hover:border-[#FF5500]" />
                <Icon className="h-6 w-6 text-[#FF5500]" strokeWidth={1.8} />
                <h3 className="font-display mt-5 text-xl font-semibold uppercase tracking-wide text-slate-100">
                  {m.name}
                </h3>
                <p className="mt-1 font-mono text-[11px] uppercase tracking-widest text-[#FF7A33]">{m.tag}</p>
                <p className="mt-3 text-sm leading-relaxed text-slate-400">{m.desc}</p>
              </div>
            </Reveal>
          );
        })}
      </div>

      <Reveal delay={0.1} className="mt-6">
        <div
          data-testid="robotics-item"
          className="flex items-start gap-5 rounded-lg border border-dashed border-slate-700 bg-[#0D1320] p-7"
        >
          <Bot className="mt-1 h-6 w-6 shrink-0 text-[#FF5500]" strokeWidth={1.8} />
          <p className="text-sm leading-relaxed text-slate-300 sm:text-base">{ROBOTICS}</p>
        </div>
      </Reveal>

      <Reveal delay={0.1} className="mt-16">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:items-center">
          <div className="clip-frame relative lg:col-span-7">
            <img
              src={IMAGES.datacenter}
              alt="High-density data-center server halls — one environment WorkSafeAgent protects"
              className="h-72 w-full object-cover sm:h-96"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0A0E17]/80 via-transparent to-transparent" />
            <p className="absolute bottom-4 left-5 font-mono text-[11px] uppercase tracking-widest text-slate-300">
              Runs on cameras already in the field
            </p>
          </div>
          <div className="lg:col-span-5">
            <h3 className="font-display text-2xl font-semibold uppercase tracking-tight text-slate-100 sm:text-3xl">
              Partners &amp; integrations
            </h3>
            <ul data-testid="partners-list" className="mt-5 space-y-3">
              {PARTNERS.map((p) => (
                <li
                  key={p}
                  className="flex items-center gap-3 border-b border-slate-800 pb-3 font-mono text-sm tracking-wide text-slate-200 last:border-b-0"
                >
                  <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-[#FF5500]" />
                  {p}
                </li>
              ))}
            </ul>
            <div className="mt-6 flex flex-wrap gap-4">
              <a
                data-testid="product-link-wsafe"
                href={CONTACT.site}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-1.5 font-mono text-xs uppercase tracking-widest text-[#FF5500] transition-colors hover:text-[#FF7A33]"
              >
                wsafe.ai <ArrowUpRight className="h-3.5 w-3.5" />
              </a>
              <a
                data-testid="product-link-worksafeagent"
                href={CONTACT.product}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-1.5 font-mono text-xs uppercase tracking-widest text-[#FF5500] transition-colors hover:text-[#FF7A33]"
              >
                worksafeagent.com <ArrowUpRight className="h-3.5 w-3.5" />
              </a>
            </div>
          </div>
        </div>
      </Reveal>
    </section>
  );
}
